import React from "react";
import {
  commonHeaderStyle,
  commonStyle,
  rowStyle2,
} from '../../Utility/Utility';
import "../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const ErrorModal = ({ open, setOpen }) => {
  const { einvItemErrorData } = useSelector(
    (state) => state.EinvReducerNew
  );

  const columns = [
    {
      dataField: "header",
      text: "Field Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "30%",
      },
    },
    {
      dataField: "error",
      text: "Error",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "70%",
      },
    },
  ];

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Error"}</Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        {einvItemErrorData?.length > 0 && (
          <>
            <div
              className="error-modal-div"
              style={{
                marginTop: "0.6em" ,
              }}
            >
              Item Errors:
            </div>
            <div className="error-table ">
              <BootstrapTable
                keyField="header"
                data={einvItemErrorData}
                columns={columns}
                rowStyle={rowStyle2}
              />
            </div>
          </>
        )}
      </MuiDialogContent>
    </Dialog>
  );
};

export default ErrorModal;
